import {Divider, Grid, Typography} from "@material-ui/core";
import PropTypes from "prop-types";

const Summary = (props) => {
    return (
        <>
            <Divider variant="fullWidth"/>
            <Grid container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center">
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="overline">Nome APN</Typography>
                </Grid>

                <Grid item
                      xs={12} sm={7} md={8}>
                    <Typography variant="subtitle2">{props.summaryForm.apnName}</Typography>
                </Grid>

                {props.summaryForm.showVrf ? <>
                    <Grid item
                          xs={12} md={12}>
                        <Divider variant="fullWidth"/>
                    </Grid>

                    <Grid item
                          xs={12} sm={5} md={4}>
                        <Typography variant="overline">Nome VRF</Typography>
                    </Grid>

                    <Grid item
                          xs={12} sm={7} md={8}>
                        <Typography variant="subtitle2">{props.summaryForm.vrfName}</Typography>
                    </Grid>
                </> : null}

            </Grid>
        </>
    )
}

Summary.propTypes = {
    summaryForm: PropTypes.shape({
        apnName: PropTypes.string.isRequired,
        showVrf: PropTypes.bool.isRequired,
        vrfName: PropTypes.string.isRequired
    })
}

export default Summary
